import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all billOfLabourMps
export const getBillOfLabourMps = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-labour-mp`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-labour-mp:", error.response?.data || error);
    throw error;
  }
};

// GET a single billOfLabourMp
export const getBillOfLabourMpById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-labour-mp/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-labour-mp:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new billOfLabourMp
export const createBillOfLabourMp = async (billOfLabourMpData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/bill-of-labour-mp`, billOfLabourMpData);
    return response.data;
  } catch (error) {
    console.error("Error creating bill-of-labour-mp:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing billOfLabourMp
export const updateBillOfLabourMp = async (id, billOfLabourMpData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/bill-of-labour-mp/${id}`, billOfLabourMpData);
    return response.data;
  } catch (error) {
    console.error("Error updating bill-of-labour-mp:", error.response?.data || error);
    throw error;
  }
};

// DELETE a billOfLabourMp
export const deleteBillOfLabourMp = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/bill-of-labour-mp/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting bill-of-labour-mp:", error.response?.data || error);
    throw error;
  }
};

// GET billOfLabourMps by maintenancePlanId
export const getBillOfLabourMpsByMaintenancePlanId = async (maintenancePlanId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-labour-mp`, {      params: { maintenancePlanId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching bill-of-labour-mp:', error.response?.data || error);
    throw error;
  }
};
